// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "worker~banner~games~games-grid~games-search~promotion-info~promotions" + "." + "c67bef79d625b6b00d57" + ".chunk.js";
};